import { render, staticRenderFns } from "./shimmer.vue?vue&type=template&id=6329e074&"
import script from "./shimmer.vue?vue&type=script&lang=js&"
export * from "./shimmer.vue?vue&type=script&lang=js&"
import style0 from "./shimmer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports